import React from "react";
import { ApplicationVersion } from "../../../generated/graphql";
import { Box } from "@material-ui/core";
import {
  MobileVersionInfo,
  MobileVersionList,
} from "../../MobileVersions/MobileVersions.style";
import { convertDateAndTimeToLocaleHandler } from "../Utils/ConvertOperations/convertTimeToLocalHandler";

interface VersionHistoryBlockProps {
  versions: ApplicationVersion[];
}

export const VersionHistoryBlock = ({ versions }: VersionHistoryBlockProps) => {
  return (
    <Box
      mt="25px"
      display="flex"
      justifyContent="flex-start"
      flexDirection="column"
      width="32%"
    >
      {versions.map((v) => (
        <MobileVersionList key={v.id || v.os}>
          <Box mt={2} display="flex" justifyContent="space-between">
            <MobileVersionInfo>{v.version}</MobileVersionInfo>
            <MobileVersionInfo>
              {convertDateAndTimeToLocaleHandler(v.createdDate)}
            </MobileVersionInfo>
          </Box>
        </MobileVersionList>
      ))}
    </Box>
  );
};
